export const maxAppWidth = 468;

export const simpleToastDuration = 2000;

export const BASE_URL_ENV = process.env.NEXT_PUBLIC_API_URL;
export const SENTRY_DSN_ENV = process.env.NEXT_PUBLIC_SENTRY_DSN;
export const SENTRY_STATUS_ENV = process.env.NEXT_PUBLIC_SENTRY_STATUS;
export const MANIFEST_ENV = process.env.NEXT_PUBLIC_MANIFEST;

export const OZONE_SOCIAL_DOMAIN = process.env.NEXT_PUBLIC_OZONE_SOCIAL_DOMAIN;
export const OZONE_CHAT_DOMAIN = process.env.NEXT_PUBLIC_OZONE_CHAT_DOMAIN;
export const OZONE_CARD_DOMAIN = process.env.NEXT_PUBLIC_OZONE_CARD_DOMAIN;

export const APP_PACKAGE_NAME = {
  develop: "app.ozone.social.dev",
  production: "app.ozone.social",
};

export const IDB_ENV = {
  uuid: (username: string) => `uuid_${username}`,
};
